import React from 'react';
import Header from "./Header";
import {NavLink} from "react-router-dom";

const Dashboard = () => {

    return (
        <div>
            <Header />
            <div className=" mt-4 mt-sm-5 " style={{maxWidth: "900px", marginLeft: "auto", marginRight: "auto"}}>
                <h3 className="text-center" >ESLATMA</h3>
                <h4 className="text-center">
                    Ushbu dastur aqlli-suv qurulmalari haqida ma'lumot, hisobotlarni olish uchun mo'ljallangan bo'lib hech qanday rasmiy dastur hisoblanmaydi!
                </h4>
                <h5 className="mt-5"># Arxiv</h5>
                <ul className="mt-2" type="square">
                    <li>2. O'zgartirish kiritildi --> <code style={{cursor: 'pointer'}} className="text-decoration-underline text-primary">07.03.2024</code></li>
                    <li>1. Ishga tushgan vaqti --> <code style={{cursor: 'pointer'}} className="text-decoration-underline text-primary">19.01.2024</code></li>
                </ul>

                <h5 className="mt-5"># Bog'lanish</h5>
                <ul className="mt-2" type="square">
                    <li>1. Savollar bo'lsa --> <code style={{cursor: 'pointer'}} className="text-decoration-underline text-primary">
                        <NavLink to="https://t.me/FKgroup">IARC</NavLink>
                    </code></li>
                    <li>2. O'zgartirish bo'lsa --> <code style={{cursor: 'pointer'}} className="text-decoration-underline text-primary">
                        <NavLink to="https://t.me/FKgroup">IARC</NavLink>
                    </code></li>
                </ul>

            </div>
        </div>
    );
};

export default Dashboard;